import { regex } from 'react-admin';

export const decimalLengthValidator = value => {
    let maxDecimals = 5;
    if (typeof value === 'number') {
        if (value.toString().split('.')[1]?.length > maxDecimals) {
            return `Max number of supported decimals is ${maxDecimals}.`;
        }
    }

    return undefined;
};

export const noCharactersFromList = list => {
    return value => {
        if (typeof value !== 'string') {
            return undefined;
        }

        const invalidCharacters = new Set(list.split(''));
        const valueCharacters = value.split('');

        const intersection = valueCharacters.filter(c => invalidCharacters.has(c));
        if (intersection.length > 0) {
            return `Następujące znaki są niedozwolone: ${list}`;
        }

        return undefined;
    };
};

export const noSpecialCharacters = noCharactersFromList('!@#$%^&*()+/\\”"\'`|<>,.[]{}');

export const validPostalCode = regex(/^\d{2}-\d{3}$/, 'Must be a valid postal code');
export const validAddress = regex(/\d/, 'Must contain a digit');

export const validGtin = value => {
    const errorMessage = 'Must be a valid GTIN code';

    if (typeof value !== 'string') {
        return errorMessage;
    }

    if (!/^\d+$/.test(value) || ![8, 12, 13, 14].includes(value.length)) {
        return errorMessage;
    }

    const digitsRev = [...value].map(Number).reverse();
    const [actualCheckDigit, ...significantDigits] = digitsRev;
    let sum = 0;
    for (let i = 0; i < significantDigits.length; i++) {
        const multiplier = i % 2 === 0 ? 3 : 1;
        sum += significantDigits[i] * multiplier;
    }
    const expectedCheckDigit = (10 - (sum % 10)) % 10;

    if (actualCheckDigit !== expectedCheckDigit) {
        return errorMessage;
    }

    return undefined;
};

export const validNip = regex(/^\d{10}$/, 'resources.contractor.validation.invalidNip');
